export const themes = {
    colors: {
      primary: "#3F50B5",
      black: "#000",
      black1: "#0000001A",
      black2: "#333",
      gray0: "#F0F0F7",
      gray1: "#717171",
      gray2: "#47464A",
      gray3: "#444444",
      gray4: "#666666",
      white: "#FFFFFF",
      white1: "#F8F9FD",
      green0: "#00875F",
      green1: "#00871E",
      disabled: "#C6C6C6",
      error: "#BA1A1A",
      red0: "#E10000",
      red1: "#E74040",
      blue0: "#DDE1FF",
      blue1: "#2096F3",
      brown0: "#795548",
      yellow: "#EDD501",
    },
    fonts: ["sans-serif", "Roboto"]
  }